import { batch } from '@tmapy/redux';
import { LAYER_TYPE } from '@tmapy/config';
import { actionSetLayerFeatures, actionSetVectorTileHiddenFeatures, getFeaturesFromLayer, } from '@tmapy/mapcore';
export const actionUnhideTileAllFeaturesByLayer = (workLayerId, tileLayerId) => (dispatch, getState) => {
    const state = getState();
    const features = getFeaturesFromLayer(state.mapCore.layers, workLayerId);
    const featureIds = features?.map((feature) => feature.id);
    const vectorTileLayer = state.mapCore.layers.find((layer) => layer.type === LAYER_TYPE.TILE_VECTOR && layer.id === tileLayerId);
    const newHiddenFeatureIds = vectorTileLayer?.hiddenFeatureIds.filter((featureId) => !featureIds?.includes(featureId));
    batch('actionUnhideTileAllFeaturesByLayer', () => {
        dispatch(actionSetLayerFeatures(workLayerId, []));
        dispatch(actionSetVectorTileHiddenFeatures(tileLayerId, newHiddenFeatureIds));
    });
};
export const actionUnhideTileFeaturesByLayer = (workLayerId, tileLayerId, featureIds) => (dispatch, getState) => {
    const state = getState();
    const features = getFeaturesFromLayer(state.mapCore.layers, workLayerId) ?? [];
    const newFeatures = features.filter((feature) => !featureIds.includes(feature.id));
    const vectorTileLayer = state.mapCore.layers.find((layer) => layer.type === LAYER_TYPE.TILE_VECTOR && layer.id === tileLayerId);
    const newHiddenFeatureIds = vectorTileLayer?.hiddenFeatureIds.filter((featureId) => !featureIds?.includes(featureId));
    batch('actionUnhideTileFeaturesByLayer', () => {
        dispatch(actionSetLayerFeatures(workLayerId, newFeatures));
        dispatch(actionSetVectorTileHiddenFeatures(tileLayerId, newHiddenFeatureIds));
    });
};
//# sourceMappingURL=actionUnhideTileFeaturesByLayer.js.map